import React, { useState } from "react";
/* Components */
import Button from "../button/button";
import { useMutation } from "react-query";
import { useForm } from "react-hook-form";
import { authLogin, authLoginSocialMedia } from "../../services/auth.service";
import { useNavigate } from "react-router-dom";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from 'react-i18next';
import useSessionStore from '../../store/useSessionStore';
import GoogleSign from '../google/GoogleSign';
import { MIX_PANEL_EVENTS } from '../../utils/constans';

const SignInForm = () => {
  const [loading, setLoading] = useState(false);
  const { show } = useSnackbarStore();
  const { setInitialEvent } = useMixPanel();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setUser, setNewUserGoogle, setClearUserGoogle } = useSessionStore();

  const mutation = useMutation(authLogin, {
    onSuccess: (data) => {
      setInitialEvent(data,MIX_PANEL_EVENTS.login);
      setUser(data?.user);
      navigate("/");
      setLoading(false);
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
    },
  });

  const mutationSocialMedia = useMutation(authLoginSocialMedia, {
    onSuccess: (data) => {
      if(data?.user?.isNew){
        console.log('MIX_PANEL_EVENTS', MIX_PANEL_EVENTS.registerGoogle);
        setInitialEvent(data,MIX_PANEL_EVENTS.registerGoogle);
        setNewUserGoogle(true);
        navigate('/');
      } else {
        console.log('MIX_PANEL_EVENTS', MIX_PANEL_EVENTS.loginGoogle);
        setInitialEvent(data,MIX_PANEL_EVENTS.loginGoogle);
        setNewUserGoogle(false);
        navigate('/');
      }
      setUser(data?.user);
      localStorage.setItem("token",data?.access_token);
      localStorage.setItem("user",JSON.stringify(data?.user))
      setLoading(false);
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
      setClearUserGoogle();
    },
  });

  const onSubmit = (form) => {
    setLoading(true);
    mutation.mutate(form);
  };

  const onGoogleSuccess = (event) => {
    console.log('onGoogleSuccess event ', event);
    mutationSocialMedia.mutate({ email: event?.email, first_name: event?.given_name, last_name: event?.family_name });
  }

  const onGoogleError = (event) => {
    console.log('onGoogleError event ', event);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 className="alt-h1">{t('logIn')}</h2>
      <div className="sso-wrapper">
        <GoogleSign onSuccess={onGoogleSuccess} onError={onGoogleError} />
        <div className="login-divider">
          <hr className="divider-hr"></hr>
          <span className="">o</span>
          <hr className="divider-hr"></hr>
        </div>
      </div>
      <div className="form-warpper">
        <div className="input-text mt-0">
          <label className="input-label">{t('email')}:</label>
          <input
            className="input-box w-full"
            type="email"
            {...register("email", {
              required: t('requiredEmail'),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: t('notValidEmail'),
              },
            })}
          />
          {errors.email && <span className="error">{errors.email.message}</span>}
        </div>
        <div className="input-text mt-2">
          <label className="input-label">{t('password')}:</label>
          <input
            className="input-box w-full"
            type="password"
            {...register("password", { required: t('requiredPassword') })}
          />
          {errors.password && (
            <span className="error">{errors.password.message}</span>
          )}
        </div>
        <div className="form-CTA">
          <Button
            label={loading ? `${t('initSession')} ...` : t('enter')}
            variant="primary"
            typeB="submit"
          />
        </div>
      </div>
    </form>
  );
};

export default SignInForm;